import type {
  ButtonNavItem,
  LanguageNavItem,
  PageNavItem,
  ThemeNavItem,
  UrlNavItem,
} from '@unifyapps/defs/types/interface';

type NavItem = UrlNavItem | ThemeNavItem | LanguageNavItem | ButtonNavItem | PageNavItem;

export function isNavSectionVisible({
  userMenuNavItems,
  localeOptions,
}: {
  userMenuNavItems: NavItem[] | undefined;
  localeOptions: { value: string; label: string }[];
}): boolean {
  if (!userMenuNavItems?.length) return false;

  if (userMenuNavItems.length === 1 && userMenuNavItems[0].type === 'LANGUAGE_SWITCHER') {
    return localeOptions.length > 1;
  }

  return Boolean(userMenuNavItems?.length);
}
